<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-6 col-sm-6 col-md-6">
      <form @submit.prevent="submit" >
        <div class="form-group" v-if="errors.length" >
          <ul class="list-group">
            <li class="list-group-item list-group-item-danger" v-for="error in errors" :key="error">{{ error }}</li>
          </ul>
        </div>
        <input type="hidden" v-model="form.id"/>
        <div class="form-group input-group-sm">
          <label >Nazwa sklepu</label>
          <input class="form-control" v-model="form.name"/>
        </div>
        <div class="form-check">
          <input class="form-check-input" v-model="form.visible" type="checkbox">
          <label >Widoczny w serwisie</label>
        </div>
        <input class="btn btn-success torre-btn btn-sm mr-2" type="submit" value="Zapisz">
        <router-link class="btn btn-secondary btn-sm" :to="{ name: 'stores' }">Anuluj</router-link>
      </form>
      </div>
    </div>
  </div>
</template>

<script>
import userService from '@/service/userService'
import axios from 'axios'
import validator from 'validator'
import un from 'underscore'
import appConfig from '@/service/config'
import flashService from '@/service/flashService'

export default {
  name: 'StoresEdit',
  data: function () {
    return {
      errors: [],
      form: {
        name: '',
        id: '',
        visible: true
      }
    }
  },
  methods: {
    validate () {
      var err = []
      if (validator.isEmpty(this.form.name)) {
        // err.push('podaj nazwe')
      }
      return err
    },
    submit: function () {
      var err = this.validate()
      if (err.length > 0) {
        this.errors = err
        return false
      }
      const req = axios({
        method: 'patch',
        url: appConfig.baseUrl + '/stores/' + this.form.id,
        data: this.form,
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
        this.errors = []
        console.log(res.data)
        flashService.add("msg",{
          type: "alert-success",
          text: "Zapisano sklep"
        });
        this.$router.push({name: 'stores'})
      }).catch(err => {
        this.errors = un.map(err.response.data.errors, item => {
          return item.message
        })
      })
    }
  },
  created: function () {
    const req = axios({
      method: 'get',
      url: appConfig.baseUrl + '/stores/' + this.$route.params.id,
      data: this.form,
      headers: {
        Authorization: userService.getAuthHeader()
      }
    })
    req.then(res => {
      this.form.name = res.data.name
      this.form.id = res.data.id
      this.form.visible = res.data.visible
    }).catch(_ => {
      this.$router.push({name: 'stores'})
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/stores/StoresEdit.vue